import { Route, Routes } from 'react-router-dom';
import { routeMap } from './route-map';

export function AppRoutes() {
  return (
    <Routes>
      {routeMap.map(route => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
}
